/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { createAndFireEvent, withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import { N200 } from '@atlaskit/theme/colors';
var editedContentStyles = css({
  color: "var(--ds-text-subtlest, ".concat(N200, ")")
});
var packageName = "@atlaskit/comment";
var packageVersion = "10.13.1";
var Edited = function Edited(_ref) {
  var children = _ref.children,
    onFocus = _ref.onFocus,
    onMouseOver = _ref.onMouseOver;
  return jsx("span", {
    css: editedContentStyles,
    onFocus: onFocus,
    onMouseOver: onMouseOver
  }, children);
};
Edited.displayName = 'Edited';
export { Edited as CommentEditedWithoutAnalytics };
var createAndFireEventOnAtlaskit = createAndFireEvent('atlaskit');

/**
 * __Comment edited__
 *
 * Mark a comment as edited by passing a `CommentEdited` component to the the edited prop of `Comment`
 */
var CommentEdited = withAnalyticsContext({
  componentName: 'commentEdited',
  packageName: packageName,
  packageVersion: packageVersion
})(withAnalyticsEvents({
  onClick: createAndFireEventOnAtlaskit({
    action: 'clicked',
    actionSubject: 'commentEdited',
    attributes: {
      componentName: 'commentEdited',
      packageName: packageName,
      packageVersion: packageVersion
    }
  })
})(Edited));
export default CommentEdited;